<template>
    <v-container fluid pt-10>
        <v-card raised style="border-top: solid; border-top-color: #10303D; border-top-width: 3px;">
            <v-toolbar flat>
                {{ tituloTela }}
                <v-spacer></v-spacer>
                <v-btn v-if="canAdd" id="addRegistro" fab small dark color="#10303D" @click="$emit('add')">
                    <v-icon dark small>fas fa-plus</v-icon>
                </v-btn>
            </v-toolbar>
            <slot/>
        </v-card>
        <AppLoaderBlockCard :overlay="isLoading"/>
    </v-container>
</template>

<script>
import AppLoaderBlockCard from '@/components/layout/AppLoaderBlockCard.vue'


export default {
    components: {
        AppLoaderBlockCard,
    },
    props: {
        isLoading: Boolean,
        tituloTela: {
            type: String,
            default: ''
        },
        canAdd: {
            type: Boolean,
            default: true
        }
    }
}
</script>


<style>
    .layoutMargin {
        margin-bottom:1%;
    }
</style>
